<template>
  <div class="boxInfo">
    <el-tabs
      type="border-card" style="height: 100%;" :value="'first'"
      @tab-click="handleTabClick"
    >
      <!--'新增分区'\'分区详情'-->
      <el-tab-pane :label="typeIndex === 1 ? $t('basicData.AddPartition') : $t('basicData.PartitionDetails')" name="first">
        <div class="addFormBox">
          <el-form
            ref="queryForm"
            class="queryFormClass"
            :model="formData"
            :rules="rules"
            :label-width="$i18n.locale==='zh'?'120px':''"
            :label-position="$i18n.locale!=='zh'?'top':'right'"
            size="small"
          >
            <el-row>
              <el-col :span="20">
                <!--分区方案名称-->
                <el-form-item :label="$t('basicData.PartitionSchemeName')" prop="name">
                  <el-input
                    v-model.trim="formData.name"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    clearable
                    maxlength="20"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--备注内容-->
                <el-form-item :label="$t('basicData.RemarkContent')">
                  <el-input
                    v-model="formData.remark"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--业务类型-->
                <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
                  <el-select v-model="formData.businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                    <el-option
                      v-for="item in BUSINESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--有始发州-->
                <el-form-item :label="$t('orderDetails.desRem') + $t('GlobalSetObj.Estado')">
                  <el-checkbox v-model="formData.stateOfOrigin" :true-label="1" :false-label="0" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="mb10 feet-r">
            <template v-if="typeIndex !== 3">
              <!--新增分区 -->
              <el-button
                v-permit:remove="'but:finance:basicData:partition:edit'"
                size="small"
                type="primary"
                @click="handleAdd"
              >{{ $t('basicData.AddPartition') }}
              </el-button>
              <el-popover
                placement="bottom-start"
                trigger="hover"
              >
                <import-download :table-data="formData" :state-list="allState" @importPartition="importPartition" />
                <!--导入/下载-->
                <template #reference>
                  <el-button size="small" plain>
                    {{ $t('basicData.ImportDownload') }}
                  </el-button>
                </template>
              </el-popover>
            </template>
            <!-- 搜索-->
            <el-input
              v-model="searchCode"
              :placeholder="$t('basicData.zipCode')"
              size="small"
              clearable
              style="width: 350px"
              @clear="clearHighlight"
            >
              <template #prepend>{{ $t('basicData.zipCode') }}</template>
              <template #append>
                <el-button icon="el-icon-search" @click="handleSearch" />
              </template>
            </el-input>
            <el-button-group>
              <el-button
                :disabled="!hasSearchResults || currentHighlightIndex <= 0"
                size="small" icon="el-icon-arrow-left"
                @click="highlightPrev"
              >{{ $t('mdfeTranslate.Previous') }}</el-button>
              <el-button
                :disabled="!hasSearchResults" size="small"
                type="primary"
              >
                {{ currentHighlightIndex + 1 }}/{{ searchResults.length }}
              </el-button>
              <el-button
                :disabled="!hasSearchResults || currentHighlightIndex >= searchResults.length - 1"
                size="small" @click="highlightNext"
              >{{ $t('mdfeTranslate.Next') }}
                <i class="el-icon-arrow-right el-icon--right" /></el-button>
            </el-button-group>
          </div>
          <div>
            <el-form
              ref="tableForm"
              :model="formData"
              label-width="0px"
              class="error-form"
              :rules="rules"
              size="small"
            >
              <virtual-scroll
                ref="virtualScroll"
                :key="key"
                :data="formData.partitionAffiliateList"
                :item-size="76"
                key-prop="key"
                @change="(virtualList) => list = virtualList"
              >
                <el-table
                  ref="tableRef"
                  :data="list"
                  row-key="key"
                  border
                  height="500"
                  :row-class-name="getRowClassName"
                  :highlight-current-row="false"
                >
                  <virtual-column width="80" type="index" />
                  <el-table-column :label="$t('basicData.PartitionName')" width="160">
                    <template #header>
                      <div>
                        <!--分区名称-->
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.PartitionName') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <el-form-item
                        :prop="`partitionAffiliateList.${scope.$index}.partitionIdentifier`"
                        :rules="rules.partitionIdentifier"
                      >
                        <el-input
                          v-model="scope.row.partitionIdentifier"
                          maxlength="50"
                          show-word-limit
                          :placeholder="$t('basicData.PartitionName')"
                        />
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <!-- 始发州  -->
                  <el-table-column :label="$t('orderDetails.desRem') + $t('GlobalSetObj.Estado')" width="220">
                    <template v-slot="scope">
                      <el-form-item
                        :prop="`partitionAffiliateList.${scope.$index}.state`"
                        :rules="rules.state"
                      >
                        <StateSelectCmp
                          :disabled="formData.stateOfOrigin === 0" :list="allState" :value="scope.row.state"
                          @input="val => scope.row.state = val"
                        />
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <!--邮编-->
                  <el-table-column>
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ $t('orderDetails.desRem') + $t('basicData.zipCode') }}</span>
                      </div>
                    </template>
                    <template v-slot="scope">
                      <el-form-item
                        :prop="'partitionAffiliateList.' + scope.$index + '.postalCode'"
                        :rules="rules.postalCode"
                      >
                        <el-input
                          v-model.trim="scope.row.postalCode"
                          type="textarea"
                          :rows="2"
                          :placeholder="$t('basicData.ZipCodeExample')"
                        />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!--操作-->
                  <el-table-column :label="$t('basicData.operate')" width="120">
                    <template v-slot="scope">
                      <!--确定删除吗？-->
                      <el-popconfirm
                        :title="$t('basicData.AreYouSureYouWantToDelete')"
                        @confirm="handleDel(scope)"
                      >
                        <template #reference>
                          <!--删除-->
                          <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </virtual-scroll>
            </el-form>
          </div>
        </div>
        <div class="addFooter">
          <!--取消-->
          <el-button @click="() => handleUpdatePage(false)">{{ $t('basicData.Cancel') }}</el-button>
          <!--保存-->
          <el-button v-permit:remove="'but:finance:basicData:partition:edit'" type="primary" @click="submitForm">{{ $t('basicData.Save') }}</el-button>
        </div>
      </el-tab-pane>
      <!--操作日志-->
      <el-tab-pane v-if="typeIndex === 2" :label="$t('basicData.OperationalLogs')" name="second">
        <operation-log v-if="isSecondActive" :edit-data="editData" />
      </el-tab-pane>
    </el-tabs>
    <!--保存提示-->
    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <div v-for="(item, ind) in errData" :key="ind" style="color: red;margin-bottom: 10px;">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <!--确 定-->
        <el-button type="primary" @click="dialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiAffiliateAdd, apiAffiliateDelete, apiAffiliateEdit, apiGetAffiliateById } from '@/api/finance/partition';
import { compressList } from '@/utils/zipcode';
import { Loading } from 'element-ui';
import StateSelectCmp from './StateSelectCmp.vue';
import { cloneDeep } from 'lodash-es';
import {
  rowComparison,
  postalCodeFormat
} from './utils';
import { BUSINESS_TYPE } from '@/views/finance/enums.js';
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';

const options = {
  lock: true,
  spinner: 'el-icon-loading',
  text: 'loading...',
  background: 'rgba(250, 250, 250, 0.6)' // 加载动画的背景
};

// 添加模板
const addTmp = {
  partitionIdentifier: '',
  postalCode: '',
  id: undefined,
  state: ''
};

export default {
  components: {
    VirtualColumn,
    'import-download': () => import('./ImportDownload'),
    'operation-log': () => import('./operationLog'),
    StateSelectCmp,
    VirtualScroll
  },
  props: {
    // 类型标识 1新增 3查看 2编辑
    typeIndex: {
      type: Number,
      default: 1
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 所有一级州
    allState: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    // 州校验
    const stateCheck = (rule, value, callback) => {
      const { stateOfOrigin } = this.formData;
      // const list = this.formData.partitionAffiliateList;
      // 没有勾选
      if (stateOfOrigin !== 1) {
        return callback();
      }

      if (!value) {
        return callback(new Error(this.$t('GlobalSetObj.pleaseChoose'))); // '请选择州'
      }

      // 是否存在相同州
      // if (list.length >= 2) {
      //   console.log(value, list);
      //   let n = 0;
      //   list.forEach(item => {
      //     if (item.state === value) {
      //       n++;
      //     }
      //   });
      //   if (n >= 2) {
      //     const str1 = this.$t('basicData.StateDuplication');
      //     callback(new Error(`${str1}`));
      //     return;
      //   }
      // }

      return callback();
    };

    // 邮编校验
    const postalCodeCheck = (rule, value, callback) => {
      // 格式校验
      {
        const [isBool, text] = postalCodeFormat(value.trim());
        if (!isBool) {
          return callback(new Error(text));
        }
      }

      // 同行比较重叠的情况
      {
        const [isBool, text] = rowComparison(value);
        console.log(isBool, text, '区间校验');
        if (!isBool) {
          return callback(new Error(text));
        }
      }

      return callback();
    };

    return {
      BUSINESS_TYPE,
      list: [],
      key: new Date().getTime(),
      isSecondActive: false,
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          // '长度在 2 到 20 个字符'
          {
            min: 2,
            max: 20,
            message: this.$t('basicData.TheLengthBetween2And20Characters'),
            trigger: ['blur', 'change']
          }
        ],
        businessType: { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },

        // 分区名称
        partitionIdentifier: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: 'blur' }
        ],

        state: [
          { validator: stateCheck, trigger: 'change' }
        ],

        // 邮编
        postalCode: [
          { required: true, validator: postalCodeCheck, trigger: ['blur', 'change'] }
        ]
      },
      errData: [],
      dialogVisible: false,
      formData: {
        name: '',
        remark: '',
        businessType: '',
        stateOfOrigin: 0,
        partitionAffiliateList: []
      },
      // 响应式数据
      visibleData: [],
      searchCode: '',
      searchResults: [],
      currentHighlightIndex: -1
    };
  },

  computed: {
    hasSearchResults() {
      return this.searchResults.length > 0;
    }
  },

  watch: {
    searchCode(newVal) {
      if (!newVal) {
        this.clearHighlight();
      } else {
        this.handleSearch(); // 自动搜索定位
      }
    }
  },
  created() {
    if (this.editData.id) {
      // 报价页面查看分区使用partitionId， 分区页面使用id
      const ids = this.typeIndex === 3 ? this.editData.partitionId : this.editData.id;
      this.asyncGetAffiliateById(ids);
    }
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'second' && !this.isSecondActive) {
        this.isSecondActive = true; // 触发 ConfigManagement 组件的加载和初始化请求
      }
    },
    // 增加分区
    handleAdd() {
      this.formData.partitionAffiliateList = this.formData.partitionAffiliateList || [];
      const obj = {
        ...addTmp,
        key: `item-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      };
      this.formData.partitionAffiliateList.push(obj);
    },
    // 导入分区
    importPartition(arr) {
      // 校验是否需要必填始发州
      {
        const { stateOfOrigin } = this.formData;
        if (stateOfOrigin === 1) {
          const isBool = arr.every(item => {
            return item.state > 0;
          });
          if (!isBool) {
            const str = this.$t('GlobalSetObj.pleaseChoose');// 请选择
            const str2 = this.$t('receivablePayable.OriginatingState'); // 始发州
            const str3 = this.$t('CenterForSorting.Import'); // 导入
            this.$message.warning(str3 + str + str2); // 请选择始发州
            return;
          }
        }
      }

      const partitionAffiliateList = cloneDeep(this.formData.partitionAffiliateList);

      // 处理逻辑
      arr.forEach(originalItem => {
        const processedItem = {
          postalCode: compressList(originalItem.zipcode || '').join(','),
          state: originalItem.state,
          partitionIdentifier: originalItem.name,
          id: originalItem.id || ''
        };

        const existingIndex = processedItem.id
          ? partitionAffiliateList.findIndex(i => i.id === processedItem.id)
          : -1;

        if (existingIndex !== -1) {
          partitionAffiliateList[existingIndex] = processedItem;
        } else if (!processedItem.id) {
          partitionAffiliateList.push(processedItem);
        }
      });
      const ArrList = partitionAffiliateList.map((item, index) => {
        return {
          ...item,
          id: item.id || '',
          key: this.generateUniqueKey(index)
        };
      });
      console.log(ArrList);
      console.log(partitionAffiliateList);
      this.formData.partitionAffiliateList = ArrList;
      this.key = new Date().getTime();
    },
    generateUniqueKey(index) {
      return `item-${Date.now()}-${index}-${Math.random().toString(36).substr(2, 9)}`;
    },
    // 删除分区
    handleDel(scope) {
      if (scope.row.id) {
        apiAffiliateDelete(scope.row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          }
        });
      }
      this.formData.partitionAffiliateList.splice(scope.$index, 1);
    },
    // 取消
    handleUpdatePage(type) {
      this.$emit('updatePage', type);
    },
    // 同一个始发州下的邮编区间校验
    // validatePostalCode() {
    //   const { stateOfOrigin, partitionAffiliateList } = this.formData;
    //   const list = cloneDeep(partitionAffiliateList);
    //
    //   if (stateOfOrigin === 0) {
    //     // 所有的一起校验
    //     const errArr = [];
    //     checkOverlap(list, errArr);
    //
    //     return errArr;
    //   }
    //
    //   return checkZipCode(list);
    // },

    // 处理提交的数据格式
    setSubmitFormDataType() {
      const { name, remark, businessType, stateOfOrigin, partitionAffiliateList } = this.formData;
      // const tableData = this.formData.partitionAffiliateList;

      const row = {
        id: undefined,
        name,
        businessType,
        remark,
        attribute: 1,
        stateOfOrigin,
        partitionAffiliateList: []
      };

      row.partitionAffiliateList = partitionAffiliateList.map(item => {
        const { postalCode, partitionIdentifier, id, state } = item;

        const obj = {
          partitionIdentifier,
          postalCode, // 邮编
          id,
          state, // 州
          partitionId: this.editData.id
        };

        // 没有勾选
        if (!stateOfOrigin) {
          obj.state = undefined;
        }

        return obj;
      });

      return row;
    },

    // 新增
    asyncAffiliateAdd(obj) {
      apiAffiliateAdd(obj).then(res => {
        const { code } = res;
        if (code !== 200) {
          return;
        }
        this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
        this.handleUpdatePage(true);
      }).catch(err => {
        console.error(err);
      });
    },
    // 查看分区详情
    asyncGetAffiliateById(ids) {
      apiGetAffiliateById(ids).then(res => {
        const { code, data } = res;
        if (code !== 200) {
          return;
        }

        if (!data || typeof data !== 'object') {
          return;
        }

        const {
          businessType,
          name,
          remark,
          stateOfOrigin,
          partitionAffiliateList
        } = data;

        const arr = (partitionAffiliateList || []).map(item => {
          const { partitionIdentifier, postalCode, id, state } = item;
          return {
            id,
            partitionIdentifier,
            postalCode,
            state: Number(state) || '',
            key: this.generateUniqueKey(id)
          };
        });

        this.formData = {
          businessType,
          name,
          remark,
          stateOfOrigin: stateOfOrigin || 0,
          partitionAffiliateList: arr
        };
      }).catch(err => {
        console.error('API request error:', err);
      });
    },

    // 编辑
    asyncAffiliateEdit(obj) {
      apiAffiliateEdit(obj).then(res => {
        const { code } = res;
        if (code !== 200) {
          return;
        }
        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
        this.handleUpdatePage(true);
      }).catch(err => {
        console.error(err);
      });
    },
    /**
     * 提交表单
     */
    async submitForm() {
      try {
        // 表单校验
        const isFormValid = await this.$refs.queryForm.validate();
        if (!isFormValid) return;

        // 分区校验
        if (this.formData.partitionAffiliateList.length === 0) {
          this.$message.warning(this.$t('basicData.PleaseAddPartitions'));
          return;
        }
        const isTableValid = await this.$refs.tableForm.validate();
        if (!isTableValid) return;

        let loading;
        try {
          loading = Loading.service(options);
          const submitData = this.setSubmitFormDataType();

          if (this.typeIndex === 1) {
            this.asyncAffiliateAdd(submitData);
          } else {
            // 编辑时，分区id需要传递过来报价页面取partitionId
            submitData.id = this.typeIndex === 3 ? this.editData.partitionId : this.editData.id;
            this.asyncAffiliateEdit(submitData);
          }
        } finally {
          if (loading) {
            loading.close();
          }
        }
      } catch (error) {
        console.error('Submission Error:', error);
      }
    },
    // 搜索处理
    handleSearch() {
      const searchTerm = this.searchCode.trim();
      const tableData = this.formData.partitionAffiliateList;

      if (!searchTerm) {
        this.searchResults = [];
        this.currentHighlightIndex = -1;
        return;
      }
      // 58000001
      // const results = tableData
      //   .map((row, index) => ({ row, index }))
      //   .filter(item => item.row.postalCode && item.row.postalCode.includes(searchTerm));

      const results = tableData
        .map((row, index) => ({ row, index }))
        .filter(item => {
          const { postalCode } = item.row;
          const postalCodeList = this.parseDataRanges(postalCode);
          console.log('postalCodeList', postalCodeList);
          const {
            matched,
            matchedRange
          } = this.postalCodeFormat(searchTerm, postalCodeList);
          console.log('matched', matched, matchedRange);
          return matched;
        });

      console.log('results', results);
      this.searchResults = results;
      this.currentHighlightIndex = results.length ? 0 : -1;

      if (results.length > 0) {
        this.$nextTick(() => this.scrollToHighlightedRow());
      }
    },

    // 下一个
    highlightNext() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex = (this.currentHighlightIndex + 1) % this.searchResults.length;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 上一个
    highlightPrev() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex =
        this.currentHighlightIndex <= 0
          ? this.searchResults.length - 1
          : this.currentHighlightIndex - 1;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 滚动到当前高亮行
    scrollToHighlightedRow() {
      // 获取表格的虚拟滚动实例
      const virtualScroll = this.$refs.virtualScroll.$el;

      if (this.currentHighlightIndex < 0) return;

      const currentMatch = this.searchResults[this.currentHighlightIndex];
      if (!currentMatch) return;

      const rowIndex = currentMatch.index;

      const rowHeight = 76; // 每行的预计高度，根据实际情况调整
      const viewportHeight = virtualScroll.clientHeight; // 可视区域高度
      // const totalRows = this.formData.partitionAffiliateList.length; // 表格总行数
      const maxRowsInViewport = Math.floor(viewportHeight / rowHeight); // 可视区域最多能显示的行数
      const startIndex = Math.max(0, rowIndex - Math.floor(maxRowsInViewport / 2)); // 计算开始滚动的行索引
      const scrollTop = rowHeight * startIndex; // 计算需要滚动的位置
      console.log('scrollTop', scrollTop, startIndex, rowIndex, maxRowsInViewport, viewportHeight);
      this.setScrollTop(scrollTop);

      // 强制表格重新渲染以应用高亮样式
      this.$nextTick(() => {
        if (this.$refs.virtualScroll && this.$refs.virtualScroll.doLayout) {
          this.$refs.virtualScroll.doLayout();
        }
      });
    },
    // 清空搜索结果
    clearHighlight() {
      this.searchCode = '';
      this.searchResults = [];
      this.currentHighlightIndex = -1;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    // 设置滚动距离
    setScrollTop(top = 0) {
      const tableRef = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper'); // 表格元素
      tableRef.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    },

    // 获取行类名
    getRowClassName({ row, rowIndex }) {
      return this.isRowHighlighted(row, rowIndex) ? 'highlighted-row' : '';
    },

    // 检查行是否高亮
    isRowHighlighted(row, rowIndex) {
      if (this.currentHighlightIndex < 0) return false;

      const currentResult = this.searchResults[this.currentHighlightIndex];
      return currentResult && currentResult.row.key === row.key;
    },
    // 邮编匹配规则
    postalCodeFormat(value, parsedRanges) {
      const number = parseFloat(value);

      let matched = false;
      let matchedRange = null;

      for (const range of parsedRanges) {
        if (range.type === 'single') {
          if (range.value.includes(number)) {
            matched = true;
            matchedRange = range;
            break;
          }
        } else if (range.type === 'range') {
          if (number >= range.start && number <= range.end) {
            matched = true;
            matchedRange = range;
            break;
          }
        }
      }
      return {
        matched,
        matchedRange
      };
    },
    // 邮编解析
    parseDataRanges(code) {
      const ranges = [];
      const parts = code.split(',');

      for (const part of parts) {
        const trimmedPart = part.trim();

        if (trimmedPart.includes('~')) {
          // 处理区间
          const [start, end] = trimmedPart.split('~').map(num => parseFloat(num.trim()));
          if (!isNaN(start) && !isNaN(end)) {
            ranges.push({ type: 'range', start, end });
          }
        } else {
          // 处理单个数字
          const num = parseFloat(trimmedPart);
          if (!isNaN(num)) {
            ranges.push({ type: 'single', value: num.toString() });
          }
        }
      }

      return ranges;
    }

    // 高亮code文本
    // highlightCode(code) {
    //   const searchTerm = this.searchCode.trim();
    //   if (!searchTerm) return code;
    //
    //   const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
    //   return code.replace(regex, '<mark class="code-highlight">$1</mark>');
    // },
    //
    // // 转义正则表达式特殊字符
    // escapeRegExp(string) {
    //   return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // }
  }
};
</script>

<style scoped lang="scss">
::v-deep .highlighted-row,
::v-deep .highlighted-row:hover > td {
  background-color: #e6f7ff !important;
}

::v-deep .highlighted-row {
  position: relative;
}

::v-deep .highlighted-row::after {
  position: absolute;
  content: '';
  width: 5px;
  height: 100%;
  background-color: #1890ff;
  left: 0;
}

::v-deep .code-highlight {
  background-color: #ffeb3b;
  padding: 2px 4px;
  border-radius: 2px;
  font-weight: bold;
}

::v-deep .el-table__row {
  transition: all 0.3s ease;
}

.boxInfo {
  height: 100%;

  ::v-deep .el-tabs__content {
    //height: calc(100% - 40px);
    padding: 0;
    //overflow-y: auto !important;

    .el-tab-pane {
      height: 100%;

      .addFormBox {
        height: calc(100vh - 96px);
        padding: 15px;
        overflow-y: auto;
      }
    }
  }

  .addFooter {
    border-top: 1px solid #ccc;
    padding: 10px;
    text-align: right;
  }
}
</style>

